import { createFileRoute } from "@tanstack/react-router";
import CostInsurancePage from "@/pages/CostInsurancePage";
export const Route = createFileRoute("/cost-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Cost & Insurance | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Detailed information on insurance coverage, Medicare, Tricare, VA benefits, and CareCredit financing for TMS, SAINT® TMS, SPRAVATO®, and psychiatric services.",
        },
        {
          property: "og:title",
          content: "Cost & Insurance | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Detailed information on insurance coverage, Medicare, Tricare, VA benefits, and CareCredit financing for TMS, SAINT® TMS, SPRAVATO®, and psychiatric services.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/cost-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/cost-insurance",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CostInsurancePage />;
}
